import { NgModule } from '@angular/core';
import { SharedModule } from '@numen/smex-lib-common-frontend';
import { AccessControlDirective, DropZoneDirective,MatAutocompleteScrollDirective } from './directives';
import { InProgressInterceptor } from './interceptors';


@NgModule({
    declarations: [
        AccessControlDirective,
        MatAutocompleteScrollDirective,
        DropZoneDirective
    ],
    imports     : [
        SharedModule
    ],
    exports     : [
        AccessControlDirective,
        MatAutocompleteScrollDirective,
        DropZoneDirective
    ],
    providers   : [
        InProgressInterceptor
    ]
})
export class LibCfnEcmCoreModule {
}
